/**
 * @generated SignedSource<<72feea6b3f7fb89ee9bd4bb43451f44b>>
 * @relayHash 6670f19dbc8f9d136407c7e957949a39
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID fbfdbe0b2d4443cb61be9eaf695ef7c8513e706c0065701b91ede232b7a8ed0a

import type { ConcreteRequest, Query } from 'relay-runtime';
export type ThemeSetterQuery$variables = {
  cloudId: string;
  projectIdOrKey: string;
};
export type ThemeSetterQuery$data = {
  readonly jira: {
    readonly mediaClientId: string | null | undefined;
    readonly mediaExternalEndpointUrl: string | null | undefined;
  };
  readonly jira_projectByIdOrKey: {
    readonly background: {
      readonly __typename: "JiraColorBackground";
      readonly colorValue: string | null | undefined;
    } | {
      readonly __typename: "JiraGradientBackground";
      readonly gradientValue: string | null | undefined;
    } | {
      readonly __typename: "JiraMediaBackground";
      readonly customBackground: {
        readonly altText: string | null | undefined;
        readonly id: string | null | undefined;
        readonly mediaApiFileId: string | null | undefined;
        readonly mediaReadToken: string | null | undefined;
        readonly sourceIdentifier: string | null | undefined;
        readonly sourceType: string | null | undefined;
      } | null | undefined;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null | undefined;
    readonly projectId: string | null | undefined;
  } | null | undefined;
};
export type ThemeSetterQuery = {
  response: ThemeSetterQuery$data;
  variables: ThemeSetterQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "projectIdOrKey"
  }
],
v1 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v2 = [
  (v1/*: any*/)
],
v3 = {
  "concreteType": "JiraQuery",
  "kind": "LinkedField",
  "name": "jira",
  "plural": false,
  "selections": [
    {
      "args": (v2/*: any*/),
      "kind": "ScalarField",
      "name": "mediaClientId"
    },
    {
      "args": (v2/*: any*/),
      "kind": "ScalarField",
      "name": "mediaExternalEndpointUrl"
    }
  ]
},
v4 = [
  (v1/*: any*/),
  {
    "kind": "Variable",
    "name": "idOrKey",
    "variableName": "projectIdOrKey"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "projectId"
},
v6 = {
  "kind": "ScalarField",
  "name": "id"
},
v7 = {
  "kind": "LinkedField",
  "name": "background",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "colorValue"
        }
      ],
      "type": "JiraColorBackground"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "gradientValue"
        }
      ],
      "type": "JiraGradientBackground"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "concreteType": "JiraCustomBackground",
          "kind": "LinkedField",
          "name": "customBackground",
          "plural": false,
          "selections": [
            (v6/*: any*/),
            {
              "kind": "ScalarField",
              "name": "mediaApiFileId"
            },
            {
              "args": [
                {
                  "kind": "Literal",
                  "name": "durationInSeconds",
                  "value": 900
                }
              ],
              "kind": "ScalarField",
              "name": "mediaReadToken",
              "storageKey": "mediaReadToken(durationInSeconds:900)"
            },
            {
              "kind": "ScalarField",
              "name": "sourceType"
            },
            {
              "kind": "ScalarField",
              "name": "sourceIdentifier"
            },
            {
              "kind": "ScalarField",
              "name": "altText"
            }
          ]
        }
      ],
      "type": "JiraMediaBackground"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ThemeSetterQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": (v3/*: any*/),
        "action": "THROW",
        "path": "jira"
      },
      {
        "args": (v4/*: any*/),
        "concreteType": "JiraProject",
        "kind": "LinkedField",
        "name": "jira_projectByIdOrKey",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v7/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ThemeSetterQuery",
    "selections": [
      (v3/*: any*/),
      {
        "args": (v4/*: any*/),
        "concreteType": "JiraProject",
        "kind": "LinkedField",
        "name": "jira_projectByIdOrKey",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v7/*: any*/),
          (v6/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "fbfdbe0b2d4443cb61be9eaf695ef7c8513e706c0065701b91ede232b7a8ed0a",
    "metadata": {},
    "name": "ThemeSetterQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "773e2b2667d22a5898638ebf9a88c900";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
